// userService.js - User related services
import fetchWithToken from './api';

/**
 * Updates the user's onboarding stage
 * @param {string} stage - The new onboarding stage
 * @returns {Promise<Object>} Updated user data
 */
export const updateOnboardingStage = async (stage) => {
    try {
        const response = await fetchWithToken('/update-onboarding-stage', {
            method: 'PATCH',
            body: JSON.stringify({ onboardingStage: stage }),
        });

        if (!response.ok) {
            throw new Error('Failed to update onboarding stage');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating onboarding stage:', error);
        throw error;
    }
};

/**
 * Fetches user data from the API based on provided fields
 * @param {string|string[]} fields - Single field name or array of field names to fetch
 * @returns {Promise<Object>} - Promise resolving to user data object
 */
export const getUserData = async (fields) => {
    let queryParams = '';
    if (fields) {
        if (Array.isArray(fields)) {
            queryParams = `?fields=${fields.join(',')}`;
        } else {
            queryParams = `?fields=${fields}`;
        }
    }

    try {
        // Use the fetchWithToken utility for authentication and token refresh
        const response = await fetchWithToken(`/user${queryParams}`, {
            method: 'GET'
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch user data: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching user data:', error);
        throw error;
    }
};
